import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppRouter } from '@/app/router'
import { queryClient } from '@/app/query-client'
import { AuthProvider } from '@/features/auth/auth-context'
import { RealtimeBridge } from '@/features/realtime/RealtimeBridge'
import { confirmR5Motion } from '@/components/r5/motion'
import { registerStaleChunkReload } from '@/lib/staleChunkReload'
import '@/styles/index.css'
import '@/styles/r5-fonts.css'
import '@/styles/r5-tokens.css'
import '@/styles/r5-motion.css'
import '@/components/r5/r5.css'
import '@/components/r5/r5-kit.css'

registerStaleChunkReload()
confirmR5Motion()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RealtimeBridge />
        <AppRouter />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
